import { useEffect, useState } from 'react'
import { Disc } from 'lucide-react'
import { useRecordingStore } from '@os/spaces/web/stores/recordingStore'

interface Props {
  channelId: string
}

function formatTimer(sec: number) {
  const m = Math.floor(sec / 60)
  const s = sec % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

/** Top-of-screen "REC" badge with elapsed timer. Mounts whenever the
 * channel has an ACTIVE / STARTING recording. */
export default function RecordingIndicator({ channelId }: Props) {
  const recording = useRecordingStore((s) => s.active[channelId])
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!recording) return
    const t = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(t)
  }, [recording])

  if (!recording) return null
  if (recording.status !== 'ACTIVE' && recording.status !== 'STARTING') return null

  const elapsed = Math.max(0, Math.floor((now - new Date(recording.startedAt).getTime()) / 1000))
  return (
    <div className="absolute top-3 left-1/2 -translate-x-1/2 z-30 px-3 py-1.5 rounded-full bg-red-600/90 text-white shadow-lg flex items-center gap-2 backdrop-blur-sm">
      <Disc size={14} className="animate-pulse" />
      <span className="text-xs font-bold tracking-wider">REC</span>
      <span className="text-xs font-mono opacity-90">{formatTimer(elapsed)}</span>
    </div>
  )
}
